<template lang="pug">
  div.legend__group
    div.legend__type
      div.legend__name.semibold {{$translate('Статус')}}
    div.legend__small-group(
      v-for="status in statuses" :key="'status-' + status.id"
      v-if="status.show"
    )
      .custom-checkbox
        input.visually-hidden.custom-checkbox__input(
          type="checkbox"
          :id="'checkbox-' + status.slug"
          v-model="status.checked"
          @change="() => updateStatus(status.slug, status.checked)"
        )
        label.legend__label.custom-checkbox__label(:for="'checkbox-' + status.slug")
          span.custom-checkbox__block
          span.legend__marker(:class="'legend__marker_' + status.slug")
          span.custom-checkbox__text {{$translate(status.name)}}
</template>

<script>
import { statuses } from '../config/statuses'

export default {
  name: 'map-statuses',
  data: () => ({
    statuses,
  }),
  methods: {
    updateStatus(type, val) {
      this.$emit('updateStatus', { type, val })
    },
  },
}
</script>
